function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.cls-3,.cls-5,.cls-8{fill:#fff;}.cls-1,.cls-2,.cls-4,.cls-8{stroke:#d5dbe9;}.cls-2,.cls-4{fill:#eef1fa;}.cls-2,.cls-3,.cls-8{fill-rule:evenodd;}.cls-6{fill:#d5dbe9;}.cls-7{fill:#007dd5;}.cls-9{fill:url(#radial-gradient);}.cls-10{fill-opacity:0.57;fill:url(#radial-gradient-2);}.cls-11{fill-opacity:0.68;fill:url(#radial-gradient-3);}.cls-12{fill-opacity:0.08;fill:url(#radial-gradient-4);}.cls-13{fill-opacity:0.03;fill:url(#linear-gradient);}"), React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: -512.84,
  cy: 351.64,
  r: 1.72,
  gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#2f80f2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#a942b5"
})), React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: -513.75,
  cy: 351.73,
  r: 1.59,
  gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#45f9de"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#a942b5",
  stopOpacity: 0
})), React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: -512.75,
  cy: 350.75,
  r: 0.96,
  gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#e957c5"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ac43b6",
  stopOpacity: 0.04
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#a942b5",
  stopOpacity: 0
})), React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: -513.25,
  cy: 351.25,
  r: 0.58,
  gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.19
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#101010"
})), React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -512.89,
  y1: 351.03,
  x2: -513.83,
  y2: 351.62,
  gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.19
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 0.5,
  y: 15.5,
  width: 78,
  height: 57,
  rx: 4
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M75,24.5A3.52,3.52,0,0,1,78.5,28h0v7.5H.5V28a3.44,3.44,0,0,1,1-2.47A3.44,3.44,0,0,1,4,24.5H75Z",
  transform: "translate(0 -9)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M5,28.2a2,2,0,1,1-2,2A2,2,0,0,1,5,28.2Zm5,0a2,2,0,1,1-2,2A2,2,0,0,1,10,28.2Zm5,0a2,2,0,1,1-2,2A2,2,0,0,1,15,28.2Z",
  transform: "translate(0 -9)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 45.5,
  y: 22.5,
  width: 57,
  height: 75,
  rx: 4
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 62,
  y: 48,
  width: 34,
  height: 4,
  rx: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 52,
  y: 47,
  width: 6,
  height: 6,
  rx: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 53,
  y: 58,
  width: 4,
  height: 4,
  rx: 1
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M54.55,60.92l2.88-3.08a.3.3,0,0,0,0-.38l-.36-.38a.23.23,0,0,0-.35,0l-2.35,2.51-1.09-1.17a.23.23,0,0,0-.35,0l-.36.38a.3.3,0,0,0,0,.38l1.63,1.74A.23.23,0,0,0,54.55,60.92Z",
  transform: "translate(0 -9)"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 62,
  y: 58,
  width: 34,
  height: 4,
  rx: 1
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 52,
  y: 82.83,
  width: 16,
  height: 9.09,
  rx: 1
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 76,
  y: 82.83,
  width: 20,
  height: 9.09,
  rx: 1
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M99,31.5a3.52,3.52,0,0,1,3.5,3.5h0v7.5h-57V35A3.52,3.52,0,0,1,49,31.5H99Z",
  transform: "translate(0 -9)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 52.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 8
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 56,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 56,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 56,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-12",
  x: 56,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 56,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "61.63 17.6 61.63 12.64 66.32 17.6 68.93 17.6 68.93 17.47 63.54 11.82 68.51 6.46 68.51 6.4 65.89 6.4 61.63 11.14 61.63 6.4 59.52 6.4 59.52 17.6 61.63 17.6"
});

var SvgKeplrAccess = function SvgKeplrAccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 103 98",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKeplrAccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keplr-access.2cf63346.svg";
export { ForwardRef as ReactComponent };